import { render, staticRenderFns } from "./GetGift.vue?vue&type=template&id=7325231c&scoped=true&"
import script from "./GetGift.vue?vue&type=script&lang=js&"
export * from "./GetGift.vue?vue&type=script&lang=js&"
import style0 from "./GetGift.vue?vue&type=style&index=0&id=7325231c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7325231c",
  null
  
)

export default component.exports